var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExitToApp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "exit_to_app_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "exit_to_app_svg__ds",
    x1: -1225.86,
    y1: 9826,
    x2: -1040.09,
    y2: 9826,
    gradientTransform: "translate(1267.98 10041.4) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m168.51,280.17c-2.38,2.38-5.55,3.7-8.92,3.7s-6.54-1.31-8.92-3.7c-4.92-4.92-4.92-12.93,0-17.85l34.16-34.16H54.74c-6.96,0-12.62-5.66-12.62-12.62s5.66-12.62,12.62-12.62h130.03l-34.45-34.46c-2.38-2.38-3.7-5.55-3.7-8.92s1.31-6.54,3.7-8.92c2.38-2.38,5.55-3.7,8.92-3.7s6.54,1.31,8.92,3.7l56.02,56.02c2.38,2.38,3.7,5.55,3.7,8.92s-1.31,6.54-3.7,8.92l-55.67,55.67Z",
    style: {
      fill: "url(#exit_to_app_svg__ds)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m384.73,69.95c-2.32-2.32-5.52-3.64-8.8-3.64h-107.94v.4h-106v-.4H54.06c-3.27,0-6.48,1.33-8.8,3.64s-3.64,5.52-3.64,8.8v83.25h24.88v-70.41h296.99v243.21H66.5v-66.81h-24.88v79.65c0,3.28,1.33,6.48,3.64,8.8s5.52,3.64,8.8,3.64h107.94v-.4h106v.4h107.94c3.27,0,6.48-1.33,8.8-3.64s3.64-5.52,3.64-8.8V78.75c0-3.28-1.33-6.48-3.64-8.8Z",
    style: {
      fill: "#f7f7f7"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitToApp);
export default __webpack_public_path__ + "static/media/exit_to_app.b9ae7e90622bf94aaf6d5a8decf5e9ea.svg";
export { ForwardRef as ReactComponent };